import { measureLineColor, measurePointFillColor, measurePointStrokeColor } from "features/engine2D";

export const POINT_LINE_LINE_COLOR = measureLineColor;

export const POINT_LINE_MARKER_FILL_COLOR = measurePointFillColor;
export const POINT_LINE_MARKER_STROKE_COLOR = measurePointStrokeColor;

export const POINT_LINE_PROJECTION_GUIDE_COLOR = "#0091FF";
